import { Icon } from '@ps/isp-web-component-library';
import { TickSmall } from '@ps/isp-web-component-library/icons/TickSmall';
import type { PlaceTerms } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classnames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';

import { EachWayPlaceTerms } from '@swf/sports/components';

import { TXTWCL_Each_Way } from './EachWayCheckbox.messages.json';
import styles from './EachWayCheckbox.scss';

interface Props {
  fieldName: string;
  placeTerms?: PlaceTerms;
}

const EachWayCheckbox: React.FC<Props> = ({ fieldName, placeTerms }) => {
  const { input } = useField(`${fieldName}.eachWaySelected`, { type: 'checkbox' });

  return (
    <div className={classnames(styles.wrapper, input.checked && styles.checked)}>
      <div className={styles.input}>
        <input {...input} id={input.name} checked={input.checked} />
        <Icon icon={TickSmall} className={styles.icon} size="xs" />
      </div>

      <label htmlFor={input.name} className={styles.label}>
        <span className={styles.name}>
          {placeTerms ? (
            <EachWayPlaceTerms placeTerms={placeTerms} />
          ) : (
            <Translation {...TXTWCL_Each_Way} />
          )}
        </span>
      </label>
    </div>
  );
};

export default EachWayCheckbox;
